import { Component, inject, input } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

import { PercentageValuePipe } from "../../../../core/pipes";
import { AdaaHelper } from "../../../../core/utils";
import { Language } from "../../../constants/enums";
import { ItemDs3Progress } from "../../../models";
import { LanguageService } from "../../../services";

@Component({
  selector: "adaa-progress-table",
  imports: [TranslatePipe, PercentageValuePipe],
  templateUrl: "./progress-table.html",
  styleUrl: "./progress-table.scss",
})
export class ProgressTableComponent {
  readonly languageService = inject(LanguageService);

  progressList = input.required<ItemDs3Progress[]>();

  readonly isArabic = AdaaHelper.getCurrentLang() === Language.Arabic;
}
